import SpecialPermissionApp from "./Functionality/SpecialPermissionApp";
import CustomTabContainer from "../../../../../../components/CustomTabContainer";
import CustomTab from "../../../../../../components/CustomTab";
import SubViewOptions from "../SubViewOptions";
import React from "react";
import {SPECIAL_PERMISSION_TAB} from "./Model/Model";
import SpecialPermissionAddEmployees from "./SubComponents/SpecialPermissionAddEmployees";
import SpecialPermissionAssignedEmployees from "./SubComponents/SpecialPermissionAssignedEmployees";
import {SEARCH_MODEL} from "../../../../../../components/table/Model/TableModel";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const SpecialPermission = (props) => {
    const {
        subView,
        changeSubViewManage,
        setBodyForExport,
        searchElement,
        setSearchElement,
        setSimpleSearch,
        setSearch,
        modified,
        setModified,
        registerAction,
        isAllChecked,
        setIsAllChecked,
        selectForDelete,
        setSelectForDelete,
        subViewChild,
        setSubViewChild
    } = props;

    const {
        t,
        DEV,
        permission,
        results,
        setResults,
        assigned
    } = SpecialPermissionApp();

    return (
        <>
            <div className="d-flex mb-3">
                <SubViewOptions
                    subView={subView}
                    changeSubViewManage={changeSubViewManage}
                />
            </div>

            <div className={"border-full-shades-200 col-12 border-radius-8px px-0"}>
                <CustomTabContainer
                    activeTab={subViewChild}
                    setActiveTab={(e) => {
                        setSearchElement("");
                        setResults(SEARCH_MODEL.clearResults());
                        setSubViewChild(e);
                    }}
                    className="border-0 px-3"
                    paddingClass=''
                >
                    {SPECIAL_PERMISSION_TAB.getTabsByPermission(DEV, permission).map((item) => (
                        <CustomTab
                            key={item.key}
                            id={item.key}
                            title={t(item.translation)}
                            icon={item.icon}
                            selected={subViewChild === item.key}
                            onClick={() => {
                                setSubViewChild(item.key)
                            }}
                            newsNumber={ item.key === SPECIAL_PERMISSION_TAB.ASSIGNED_EMPLOYEES.key ? assigned : undefined }
                        />
                    ))}
                </CustomTabContainer>

                <div className="border-bottom-shades-300 mb-3" />

                { subViewChild === SPECIAL_PERMISSION_TAB.ADD_EMPLOYEES.key &&
                    <SpecialPermissionAddEmployees
                        setBodyForExport={setBodyForExport}
                        results={results}
                        setResults={setResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        modified={modified}
                        setModified={setModified}
                        registerAction={registerAction}
                        selected={selectForDelete}
                        setSelected={setSelectForDelete}
                    />
                }

                { subViewChild === SPECIAL_PERMISSION_TAB.ASSIGNED_EMPLOYEES.key &&
                    <SpecialPermissionAssignedEmployees
                        setBodyForExport={setBodyForExport}
                        results={results}
                        setResults={setResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        modified={modified}
                        setModified={setModified}
                        registerAction={registerAction}
                        selected={selectForDelete}
                        setSelected={setSelectForDelete}
                        isAllChecked={isAllChecked}
                        setIsAllChecked={setIsAllChecked}
                    />
                }
            </div>
        </>
    );

}

export default SpecialPermission
